module.exports = __webpack_public_path__ + "static/media/Kennan_Salisbury_Resume_2020.84513f3f.pdf";